import { getElementRect } from '@src/framework/editor/src/page/index/components/canvas/element-wrapper/utils';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { Color, ColorFill, Container, SvgGraphics } from '@tencent/alloy-renderer';
import { IDisposable } from '@tencent/alloy-renderer/dist/lib/event-emitter';
import ua from '@tencent/docs-user-agent';
import { CANVAS_WORD_ART_EVENT_AREA_ID } from '../../../id-constants';
import { InterfaceFactoryOptions } from '../../elements/factory-options.interface';
import { InterfaceRendererShapeComponent } from '../../elements/types';
import { TextEditor } from '../text-editor';

export class WordArtEventArea extends Container {
    // 基础 graphics 部分
    private parentComponent: InterfaceRendererShapeComponent;
    // 图形构造入参
    private factoryOptions: InterfaceFactoryOptions<IShapeModel>;
    // graphics
    private graphics: SvgGraphics | null;

    private touchStartDisposer?: IDisposable;
    private clickDisposer?: IDisposable;

    public constructor(
        factoryOptions: InterfaceFactoryOptions<IShapeModel>,
        parentComponent: InterfaceRendererShapeComponent,
    ) {
        super();
        this.id = CANVAS_WORD_ART_EVENT_AREA_ID;
        this.factoryOptions = factoryOptions;
        this.parentComponent = parentComponent;
        this.bindEvent();
    }

    public dispose = () => {
        super.dispose();
        this.touchStartDisposer?.dispose();
        this.clickDisposer?.dispose();
    };

    public update = () => {
        this.renderSvgGraphics();
    };

    // 绑定事件
    private bindEvent = () => {
        if (ua.isMobile) {
            this.touchStartDisposer = this.onTouchStart(this.clickAndTouchCallback);
        } else {
            this.clickDisposer = this.onClick(this.clickAndTouchCallback);
        }
    };

    // 点击/触摸回调
    private clickAndTouchCallback = () => {
        const textEditor = (this.parentComponent as any).textEditor as TextEditor | null;
        if (this.parent && textEditor) {
            this.parent.visible = true;
            textEditor.editorContainer.visible = false;
        }
    };

    private renderSvgGraphics = () => {
        const rect = getElementRect({ element: this.factoryOptions.model, tableResizing: false, useAdvHas: false });
        const width = rect.width + 20;
        const height = rect.height + 20;
        const path = `M 0 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`;

        if (!this.graphics) {
            this.graphics = new SvgGraphics(path);
            this.graphics.y = -10;
            this.graphics.x = -10;
            this.graphics.fill = new ColorFill(Color.Transparent);
            this.addChild(this.graphics);
        } else {
            this.graphics.path = path;
        }
    };
}
